import { useCallback } from 'react';

import { ConsumerList, useListConsumerLists } from '@givebacks/api/backer';
import { ClickableOptionsCard } from 'core/Components';
import { Skeleton, Stack, Text } from 'ui';

import { ListSubscriptionSwitch } from './ListSubscriptionSwitch';

const Lists = ({
  causeId,
  token,
  lists,
}: {
  causeId?: string;
  token?: string;
  lists?: ConsumerList[];
}) => {
  const description = useCallback((list: ConsumerList) => {
    if (list.status == 'requested') {
      return 'Request Pending...';
    } else if (list.status == 'rejected') {
      return 'Request Denied';
    }
    return list.description ?? '';
  }, []);

  return (
    <ClickableOptionsCard>
      {(lists || []).map((list) => (
        <ClickableOptionsCard.Row
          key={list.uuid}
          title={list.name}
          subtitle={description(list)}
          rightSection={<ListSubscriptionSwitch list={list} causeId={causeId} token={token} />}
        />
      ))}
    </ClickableOptionsCard>
  );
};

const CommunicationLists = ({ causeId, token }: { causeId?: string; token?: string }) => {
  const { data, isLoading, isFetched } = useListConsumerLists({ causeId, token });

  return (
    <Skeleton visible={isLoading || !isFetched}>
      {(Number(data?.lists?.length) > 0 || !isFetched) && (
        <Stack gap="lg">
          <Stack gap={'xs'}>
            <Text fz={18} fw={600}>
              Communication Lists
            </Text>
            <Text fz={12} fw={400} c="gray.6">
              Select the communication lists you would like to join. Some of these lists may require
              approval before you are granted access.
            </Text>
          </Stack>

          <Lists causeId={causeId} token={token} lists={data?.lists} />
        </Stack>
      )}
    </Skeleton>
  );
};

export { CommunicationLists };
